import { Outlet } from 'react-router-dom';
import MainHeader from "../components/mainheader/Mainheader";
import Footer from "../components/footer/Footer";

function Layout() {
  return (
    <>
      <MainHeader />
      <Outlet/>
      <Footer />
    </>
  )
}

export default Layout